export default {
    init() {
        const items = document.querySelectorAll('a[data-imgurl]');
        items.forEach((item) => {
            item.addEventListener('click', function () {
                document
                    .querySelector('.js-image-modal--frame')
                    .setAttribute('src', this.dataset.imgurl);
            },
            true);
        });
    },
};
